export const alertRuleFormLabels = {
  alert: "Alert",
  pursTotal: "PURS Score",
  bradenTotal: "Braden Score",
  nortonPlusTotal: "Norton Plus Score"
};
